import React, { useState } from 'react'
import { 
  Button,  
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner
} from 'reactstrap'

const IdentityVerificationModal = ({
  open,
  showLoading,
  form_contact_id,
  identifyVerification
}) => {
  const [ identificationDigits, onChangeDigits ] = useState( '' ) 
  return (
    <Modal    
      backdropClassName={ 'e-sign-verify-modal-backdrop' }
      contentClassName={ 'e-sign-verify-modal' }
      style={{ maxWidth: '100vw', justifyContent: 'center' }}
      centered={ true }
      isOpen={ open }>
      <ModalHeader>Verification</ModalHeader>
      <ModalBody>
        <p className={ 'mb-2' }>
          Welcome to the IQI e-signing platform. 
          You have been assigned a contract that requires your signature. 
        </p>
        <p className={ 'mb-3' }>
          To get started and so that we can verify you, 
          please enter the last 6 characters of your IC or passport number below. 
          <br/>
          ( alphanumeric characters included )
        </p>
        <Input
          type={ 'text' }
          value={ identificationDigits }
          onChange={ e => onChangeDigits( e.target.value.replace( /[^$0-9a-zA-Z]/g, '' ))}/>
        <div className={ 'd-flex mt-3' }>
        {
          !showLoading && (
            <Button 
              disabled={ identificationDigits.length < 1 }
              className={ 'ml-auto' } 
              color="primary" 
              onClick={ () => identifyVerification( form_contact_id, identificationDigits )}>
              Verify
            </Button>
          )
        }
        {
          showLoading && (
            <Spinner className={ 'ml-auto' } color="primary" />
          )
        }
        </div>
      </ModalBody>
    </Modal>
  )
}
export default IdentityVerificationModal;